interface PROPS {
  text: string;
}

export function G_IMAGE__view_no_image({ text }: PROPS) {
  return <div className="view_image_not_generated_yet relative size-full flex-center max-h-full text-component-item-foreground">{text}</div>;
}
